import type { CategoriesToGroupsOptions } from '@/features/categories/utils/categories-to-groups';
import { CategorySelect } from '../category-select';
import { Field, FieldDescription, FieldError, FieldLabel } from '../ui/field';

interface FieldCategorySelectProps {
  label: string;
  id?: string;
  description?: string;
  errors?: Array<{ message?: string } | undefined>;
  required?: boolean;
  disabled?: boolean;
  value: string | null;
  onValueChange: (value: string | null) => void;
  placeholder?: string;
  /** Show "Uncategorized" top-level item. Default: true */
  showUncategorized?: boolean;
  /** Options passed to categoriesToGroups (filterBySplitType, alwaysIncludeId) */
  categoriesToGroupsOptions?: CategoriesToGroupsOptions;
  'aria-label'?: string;
}

export function FieldCategorySelect({
  label,
  id,
  description,
  errors,
  required = false,
  disabled = false,
  value,
  onValueChange,
  placeholder = 'Select a category',
  showUncategorized = true,
  categoriesToGroupsOptions,
  'aria-label': ariaLabel
}: FieldCategorySelectProps) {
  return (
    <Field data-invalid={errors?.some((e) => e?.message) ? 'true' : undefined}>
      <FieldLabel className='gap-1'>
        {label} {required && <span className='text-destructive'>*</span>}
      </FieldLabel>

      <CategorySelect
        id={id}
        value={value}
        onValueChange={onValueChange}
        showUncategorized={showUncategorized}
        categoriesToGroupsOptions={categoriesToGroupsOptions}
        placeholder={placeholder}
        disabled={disabled}
        aria-label={ariaLabel}
      />

      {description && <FieldDescription>{description}</FieldDescription>}
      <FieldError errors={errors} />
    </Field>
  );
}
